// extracted by mini-css-extract-plugin
export default {"groupQrCode":"modalInbox_groupQrCode__Q2I9R","qrCode":"modalInbox_qrCode__9MlXr","connectionSteps":"modalInbox_connectionSteps__zzsr3"};